import axios from '@/plugins/axios'

export default {
  users (query = '') {
    return axios.get(`/inspector/inspectors${query}`)
  },
}
